import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { openTermsAndConditionsDialog, socialMediaClicked } from '../home/home.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  
  openTermsAndConditionsDialog = openTermsAndConditionsDialog;
  socialMediaClicked = socialMediaClicked;
  constructor(private dialog: MatDialog, private gaService: GAnalyticsService) { }

  ngOnInit(): void {
  }
}
